export default "__VITE_ASSET__CXj96Dwu__"